// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      causeOptions: [
        "Human",
        "Training",
        "Planning",
        "Budget",
        "Design",
        "Vendor",
        "Management",
        "Quality",
        "Processes",
        "Procedure",
        "Standards",
        "Contractor",
        "Engineering",
        "Factory"
      ],
      // eslint-disable-next-line
      incidentOutcomeOptions: [
        "NC",
        "PC",
        "CU",
        "CF",
        "RCA"
      ],
      // eslint-disable-next-line
      incidentRecommendationCloseOptions: [
        "R0",
        "R1",
        "R2",
        "R3",
        "R4"
      ],
      // eslint-disable-next-line
      investigationMethodOptions: [
        "Basic",
        "Ops",
        "Swift",
        "5 Whys",
        "Event Tree",
        "Fault Tree",
        "RCA",
        "Appolo",
        "Major",
        "C4"
      ],
      // eslint-disable-next-line
      siteInductionOptions: [
        "Free",
        "Induction",
        "Training"
      ]
    };
  }
};
